import { describeArc, valueToAngle } from "../utils/arc-math";
import type { GaugeSegment, GaugeConfig } from "../types";

export const GaugeArc = ({
  segments,
  config
}: {
  segments: GaugeSegment[];
  config: GaugeConfig;
}) => {
  const { center, radius, strokeWidth, minValue, maxValue } = config;

  // Gap in degrees between segments
  const gapDegrees = 8;

  return (
    <g>
      {segments.map((segment, index) => {
        const startAngle = valueToAngle(segment.min, minValue, maxValue);
        const endAngle = valueToAngle(segment.max, minValue, maxValue);

        // Add gap: reduce start angle and increase end angle (since angles decrease left to right)
        const adjustedStartAngle =
          index === 0 ? startAngle : startAngle - gapDegrees / 2;
        const adjustedEndAngle =
          index === segments.length - 1 ? endAngle : endAngle + gapDegrees / 2;

        const pathData = describeArc(
          center.x,
          center.y,
          radius,
          adjustedStartAngle,
          adjustedEndAngle
        );

        return (
          <path
            key={index}
            d={pathData}
            fill="none"
            stroke={segment.color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
        );
      })}
    </g>
  );
};
